export default Object.freeze({
  CREATE_SHIPMENT: 40_010,
  EDIT_SHIPMENT: 40_011,
  DELETE_SHIPMENT: 40_012,
  STOP_SHIPMENT: 40_013,
  DONE_SHIPMENT: 40_014,
  NOT_IN_TIME_SHIPMENT: 40_016,
  CREATE_DEEPLINK: 40_020,
  ADD_DEVICE: 40_030,
  REMOVE_DEVICE: 40_032,
  ADD_DELIVERY: 40_040,
  EDIT_DELIVERY: 40_041,
  REMOVE_DELIVERY: 40_042,
  DONE_CHECKPOINT: 40_044,
  NOT_IN_TIME_CHECKPOINT: 40_046,
  ADD_CARGO: 40_050,
  EDIT_CARGO: 40_051,
  REMOVE_CARGO: 40_052,
  UPLOAD_FILE: 40_060,
  REMOVE_FILE: 40_062,
  ADD_ALERT: 40_070,
  REMOVE_ALERT: 40_072,
  TRIGGER_ALERT: 40_075,
  ASSIGN_ALERT_TO_DEVICE: 40_080,
  UNASSIGN_ALERT_FROM_DEVICE: 40_082,
  ADD_NOTIFICATION: 40_090,
  EDIT_NOTIFICATION: 40_091,
  REMOVE_NOTIFICATION: 40_092,
  ADD_ALERT_CONFIRMATION: 40_100,
  EDIT_ALERT_CONFIRMATION: 40_101,
  REMOVE_ALERT_CONFIRMATION: 40_102
});
